/*
 * Author: Harper Yan
 * File Created: Monday, 25-02-17 11:51 am
 * Last Modified: Thursday, 25-02-27 06:30 pm, by Ben Zhao
 */

export const filterDisabled = (data: any): any => {
  // If data is an array, filter out disabled items and recursively filter any nested arrays
  if (Array.isArray(data)) {
    return data
      .filter((item: any) => !item.disabled) // Filter out items where disabled is true
      .map((item: any) => {
        // Recursively call filterDisabled for any nested arrays within the item
        const filteredItem = { ...item };
        Object.keys(filteredItem).forEach((key) => {
          if (typeof filteredItem[key] === 'object') {
            filteredItem[key] = filterDisabled(filteredItem[key]);
          }
        });
        return filteredItem;
      });
  } else if (typeof data === 'object' && data !== null) {
    const res = { ...data };

    const keys = Object.keys(data);
    for (const key of keys) {
      if (Array.isArray(res[key])) {
        res[key] = filterDisabled(res[key]);
      }
    }

    return res;
  }

  return data;
};
